// src/components/button/TogglePanels.tsx

import {
  Looks3TwoTone,
  Looks4TwoTone,
  Looks5TwoTone,
  LooksOneTwoTone,
  LooksTwoTwoTone,
} from '@mui/icons-material'
import {
  FormControl,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
} from '@mui/material'
import { useState } from 'react'

const data = [
  { icon: <LooksOneTwoTone />, value: 1 },
  { icon: <LooksTwoTwoTone />, value: 2 },
  { icon: <Looks3TwoTone />, value: 3 },
  { icon: <Looks4TwoTone />, value: 4 },
  { icon: <Looks5TwoTone />, value: 5 },
]

type TogglePanelsProps = {
  onChange: (value: number) => void
  value: number
}

export const TogglePanels = ({ onChange, value }: TogglePanelsProps) => {
  const [amount, setAmount] = useState(value)

  return (
    <FormControl>
      <Tooltip title={'Kacheln pro Reihe'}>
        <ToggleButtonGroup exclusive value={amount}>
          {data.map(item => (
            <ToggleButton
              key={item.value}
              onClick={() => {
                setAmount(item.value)
                onChange(item.value)
              }}
              value={item.value}
            >
              {item.icon}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Tooltip>
    </FormControl>
  )
}
